<!-- TEMPLATE FOR MODAL DIALOG -->
<div class="modal-header d-flex justify-content-between align-items-start">
  <div class="modal-title">
      <h3><i class="fa-regular fa-at me-2"></i>Kontakta support</h3>
  </div>
  <button type="button" class="btn-close" (click)="close()" aria-label="Close">
  </button>
</div>

<div class="modal-body">
  <div class="container-fluid">
      <div class="d-flex flex-column gap-3">
          @if(!successMessage) {
              <div class="flex-fill">
                  <p-floatlabel variant="on" class="contact-support-field">
                      <input #txtName pInputText fluid id="txtName" type="text" [(ngModel)]="name" (input)="validateInputs()"/>
                      <label for="txtName">Ditt namn</label>
                  </p-floatlabel>
              </div>

              <div class="flex-fill">
                  <p-floatlabel variant="on" class="contact-support-field">
                      <input pInputText fluid id="txtEmail" type="email" [(ngModel)]="email" (input)="validateInputs()"/>
                      <label for="txtEmail">Din e-postadress</label>
                  </p-floatlabel>
              </div>

              <div class="flex-fill">
                  <p-floatlabel variant="on" class="contact-support-field">
                      <input pInputText fluid id="txtSubject" type="text" [(ngModel)]="subject" (input)="validateInputs()"/>
                      <label for="txtSubject">Ärende</label>
                  </p-floatlabel>
              </div>

              <div class="flex-fill">
                  <p-floatlabel variant="on" class="contact-support-field">
                      <textarea pTextarea fluid id="txtMsg" [(ngModel)]="message" rows="5" (input)="validateInputs()"></textarea>
                      <label for="txtMsg">Meddelande</label>
                  </p-floatlabel>
              </div>
          } @else {
              <div class="flex-fill">
                  <div class="alert alert-success m-0" [innerHTML]="successMessage"></div>
              </div>
          }

          @if(errorMessage) {
              <div class="flex-fill">
                  <div class="alert alert-danger m-0" [innerHTML]="errorMessage"></div>
              </div>
          }
      </div>
  </div>
</div>

<div class="modal-footer p-2">
  @if(successMessage) {
      <button class="btn btn-sm btn-danger" (click)="close()">Stäng</button>
  } @else {
      <button class="btn btn-sm btn-primary" [disabled]="!enableSend" (click)="contactSupport()">Skicka <i class="ms-2 fa-regular fa-paper-plane"></i></button>
  }
</div>

